import type { ReactNode } from 'react'
import React from 'react'
import { Link } from 'react-router-dom'
import { Breadcrumb as BreadcrumbCore } from 'react-bootstrap'

export type BreadcrumbItem = {
  name?: string
  url?: string
  path?: string
  component?: ReactNode
}

export type BreadcrumbProps = { items?: BreadcrumbItem[] }

export const Breadcrumb = ({ items = [] }: BreadcrumbProps) => {
  return (
    <BreadcrumbCore>
      {items.map((m, i) => {
        let content = <strong>{m.component ?? m.name}</strong>
        if ((m.url || m.path) && i !== items.length - 1) {
          content = <Link to={m.url || m.path}>{m.component ?? m.name}</Link>
        }

        return (
          <BreadcrumbCore.Item linkAs="span" key={i}>
            {content}
          </BreadcrumbCore.Item>
        )
      })}
    </BreadcrumbCore>
  )
}
